import { RouteObject, useParams, useSearchParams } from "react-router-dom";
import { PermissionedRoutes } from "../../components/PermissionedRoutes";

export const SURVEY_ROUTES: RouteObject[] = [
  {
    children: [
      {
        index: true,
        async lazy() {
          const { SurveyList } = await import("./list/SurveyList");
          return {
            Component() {
              const [searchParams] = useSearchParams();
              return <SurveyList selectedId={searchParams.get("selectedId") ?? null} />;
            },
          };
        },
      },
      {
        element: <PermissionedRoutes requiredPermissions={["indigo.change_survey"]} />,
        children: [
          {
            path: ":surveyId/:section?",
            async lazy() {
              const { SurveyCreate } = await import("./create/SurveyCreate");
              return {
                Component() {
                  const params = useParams<{
                    surveyId: string;
                    section: string;
                  }>();
                  return (
                    <SurveyCreate
                      surveyId={params.surveyId ?? ""}
                      section={params.section ?? null}
                    />
                  );
                },
              };
            },
          },
        ],
      },
    ],
  },
];
